module.exports = __webpack_public_path__ + "img/icon-star.ac396607.svg";